import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4e48a340"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-backdrop" }, null, -1))
const _hoisted_2 = { class: "ReportPage" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Registro Códigos Tr. Inventarios", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_5 = {
  class: "row g-3 needs-validation",
  novalidate: ""
}
const _hoisted_6 = { class: "col-md-2" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "validationCustom01",
  class: "form-label"
}, "Código", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "valid-feedback" }, " Looks good! ", -1))
const _hoisted_9 = { class: "col-md-3" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "validationCustom02",
  class: "form-label"
}, "Descripción", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "valid-feedback" }, " Looks good! ", -1))
const _hoisted_12 = { class: "col-md-2" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "validationCustom04",
  class: "form-label"
}, "Acción", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "S",
  selected: ""
}, "Suma", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "R" }, "Resta", -1))
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "invalid-feedback" }, " Please select a valid state. ", -1))
const _hoisted_18 = { class: "col-md-2" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "validationCustom04",
  class: "form-label"
}, "Cltes", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "S",
  selected: ""
}, "Sí", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "N" }, "No", -1))
const _hoisted_22 = [
  _hoisted_20,
  _hoisted_21
]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "invalid-feedback" }, " Please select a valid state. ", -1))
const _hoisted_24 = { class: "col-md-1" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "validationCustom02",
  class: "form-label"
}, "Secuencia", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "valid-feedback" }, " Looks good! ", -1))
const _hoisted_27 = { class: "col-md-2" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "validationCustom04",
  class: "form-label"
}, "Estado", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "A",
  selected: ""
}, "Activo", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "I" }, "Inactivo", -1))
const _hoisted_31 = [
  _hoisted_29,
  _hoisted_30
]
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "invalid-feedback" }, " Please select a valid state. ", -1))

import { Ref,ref } from 'vue'
import { useDateTimeStore } from '@/store/dateTimeStore';
import { userGlobalStore } from '@/store/userGlobal';
import { UrlGlobal } from '@/store/dominioGlobal';


export default /*#__PURE__*/_defineComponent({
  __name: 'InLogTral',
  props: {
    btnIn: Boolean,
},
  emits: ['insertProps'],
  setup(__props, { emit: __emit }) {

const dUrl = UrlGlobal()
const dateTimeStore = useDateTimeStore();
const userStore = userGlobalStore();

//variables reactivas para los campos del formulario
const codigo = ref<string>('')
const descripcion = ref<string>('')
const accion = ref<string>('')
const maneja_cliente = ref<string>('')
const sec_reserva = ref<string>('')
const status = ref<string>('')

//props y emits----------------------------------------------------------------
const props = __props
const emits = __emit
        const handleClick = () =>{
            emits("insertProps",!props.btnIn)
        }
//----------------------------------------------------------------

// envio del insert a la tabla en la base de datos a traves de la api en django
const handleSubmit = async () =>{
    dateTimeStore.refreshDateTime();
    console.log(dateTimeStore.formattedDate)
    const data = {
        model:"logtral",
        data:{
            codigo:codigo.value,
            descripcion:descripcion.value,
            accion:accion.value,
            maneja_cliente:maneja_cliente.value,
            status:status.value,
            creado_por:userStore.globalUser,
            fecha_creado:dateTimeStore.formattedDate,
            hora_creado:dateTimeStore.formattedTime
        }
    }
    try {
        const response = await fetch(dUrl.urlGlobal +'/api2/insert/',{
            method: 'POST',
            headers:{
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        })
        if(response.ok){
            const responseData = await response.json()
            console.log("Insercion exitosa:",responseData)
            handleClick()
        }else{
            console.error("Error al insertar en la base de datos:",response.statusText)
        }
    }catch (error){
        console.error("error de red:",error)
    }
}
//----------------------------------------------------------------------------------------------

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("form", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((codigo).value = $event)),
            class: "form-control",
            id: "validationCustom01",
            required: ""
          }, null, 512), [
            [_vModelText, codigo.value]
          ]),
          _hoisted_8
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((descripcion).value = $event)),
            class: "form-control",
            id: "validationCustom02",
            required: ""
          }, null, 512), [
            [_vModelText, descripcion.value]
          ]),
          _hoisted_11
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _withDirectives(_createElementVNode("select", {
            class: "form-select",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((accion).value = $event)),
            id: "validationCustom04",
            required: ""
          }, _hoisted_16, 512), [
            [_vModelSelect, accion.value]
          ]),
          _hoisted_17
        ]),
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          _withDirectives(_createElementVNode("select", {
            class: "form-select",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((maneja_cliente).value = $event)),
            id: "validationCustom04",
            required: ""
          }, _hoisted_22, 512), [
            [_vModelSelect, maneja_cliente.value]
          ]),
          _hoisted_23
        ]),
        _createElementVNode("div", _hoisted_24, [
          _hoisted_25,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((sec_reserva).value = $event)),
            class: "form-control",
            id: "validationCustom02",
            required: "",
            disabled: ""
          }, null, 512), [
            [_vModelText, sec_reserva.value]
          ]),
          _hoisted_26
        ]),
        _createElementVNode("div", _hoisted_27, [
          _hoisted_28,
          _withDirectives(_createElementVNode("select", {
            class: "form-select",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((status).value = $event)),
            id: "validationCustom04",
            required: ""
          }, _hoisted_31, 512), [
            [_vModelSelect, status.value]
          ]),
          _hoisted_32
        ]),
        _createElementVNode("div", { class: "col-12" }, [
          _createElementVNode("button", {
            class: "btn btn-secondary me-2",
            type: "button",
            style: {"background-color":"#24292F"},
            onClick: handleClick
          }, "Cancelar"),
          _createElementVNode("button", {
            class: "btn btn-primary",
            type: "button",
            style: {"background-color":"#001982"},
            onClick: handleSubmit
          }, "Enviar")
        ])
      ])
    ])
  ], 64))
}
}

})